import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ThemeProvider } from "./components/ThemeProvider";
import posthog from "posthog-js";

// PostHog analytics — publishable key, safe to ship
const POSTHOG_KEY = "phc_AwwB3Eah9cugXkhLWmEvgpnnENBWuT8hYLPWTB7QU6dd";
const POSTHOG_HOST = "https://us.i.posthog.com";

if (POSTHOG_KEY && typeof window !== "undefined") {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    // autocapture mutates the DOM and conflicts with React 18's commit phase
    // on some mobile browsers, causing a fatal `removeChild NotFoundError`
    // that leaves the page completely blank. Disable it — pageviews still tracked.
    autocapture: false,
    disable_session_recording: true,
    persistence: "localStorage",
  });
  (window as any).posthog = posthog;
}

createRoot(document.getElementById("root")!).render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
